import {FILE_TYPE} from "../../../../constants/file-image-types";

export default item => ({...item, type: FILE_TYPE.IMAGE})